import { Box, styled } from "@mui/material";
import { GridRow } from "@mui/x-data-grid-pro";
import { DataGrid, Typography } from "@pmag/ui-components";

export const SparePartsListDataGrid = styled(DataGrid)(({ theme }) => ({
    "& .MuiDataGrid-main": {
        boxShadow: "unset",
    },
    // this is a dirty hack to override the inline css of datagrid markup.
    // it's because we're rendering some additional content inside DataGridRow when selecting a row. and as the datagrid itself gets inline css with fixed height a inline scrollbar would appear. at the moment there is no better way to do that. i already talked to piotr and daniel but they also said at the moment we don't have a better solution.
    "& .MuiDataGrid-virtualScrollerContent": {
        height: "auto !important",
        "& .MuiDataGrid-virtualScrollerRenderZone": {
            position: "relative",
        },
        "& .MuiDataGrid-row, & .MuiDataGrid-cell": {
            maxHeight: "none !important",
        },
    },
    "& .MuiDataGrid-cell": {
        display: "flex",
        alignItems: "center",
    },
    "& .MuiDataGrid-row:hover, & .MuiDataGrid-row.Mui-highlight": {
        backgroundColor: theme.palette.blue._10,
        "& + .MuiBox-root": {
            backgroundColor: theme.palette.blue._10,
        },
    },
}));

export const DataGridRowStyled = styled(GridRow)(({ theme, row }) => ({
    "&.Mui-selected.Mui-selected": {
        "& .MuiDataGrid-cell:first-of-type": {
            boxShadow: `inset 2px 0 ${theme.palette.core.grey._90}`,
        },
    },
}));

export const ArticleInfoBox = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
}));

export const ArticleImage = styled("img")(({ theme }) => ({
    width: "48px",
    height: "48px",
    objectFit: "contain",
    marginRight: theme.spacing(2),
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
    marginLeft: theme.spacing(2),
}));

export const LineNumberChip = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    backgroundColor: theme.palette.core.grey._70,
    borderBottomRightRadius: 12,
    borderTopRightRadius: 12,
    height: 24,
    padding: theme.spacing(0, 4),
    marginLeft: "-10px",
}));
